"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This component implements https://confluence.oci.oraclecorp.com/display/UX/Tooltips
 */
var React = require("react");
var FocusTrap_1 = require("@oui/core/FocusTrap");
var useAllCallbacks_1 = require("@oui/core/useAllCallbacks");
var Aria_1 = require("../resources/Aria");
var interactiveElementQuery = [
    "a[href]:not([disabled])",
    "button:not([disabled])",
    "textarea:not([disabled])",
    'input[type="text"]:not([disabled])',
    'input[type="radio"]:not([disabled])',
    'input[type="checkbox"]:not([disabled])',
    "select:not([disabled])"
].join(",");
var focusableElements = function (el) {
    return Array.from(el.querySelectorAll(interactiveElementQuery));
};
var hasFocusableElements = function (el) {
    return focusableElements(el).length > 0;
};
var hasClickKey = function (key) { return ["Enter", " "].indexOf(key) !== -1; };
/**
 * OUI tooltip component.
 *
 * @oui-component Tooltip
 */
var Tooltip = function (_a) {
    var children = _a.children, testId = _a.testId, onKeyDown = _a.onKeyDown, rest = __rest(_a, ["children", "testId", "onKeyDown"]);
    var _b = __read(React.useState(null), 2), ref = _b[0], setRef = _b[1];
    var _c = __read(React.useState(null), 2), disclosure = _c[0], setDisclosure = _c[1];
    var refCallback = function (node) {
        setRef(node);
        setDisclosure(node ? node.previousElementSibling : null);
    };
    var _d = __read(React.useState(false), 2), hasFocusTrap = _d[0], setHasFocusTrap = _d[1];
    var hide = React.useCallback(function () {
        global.ouiUIkit.dropdown(ref).hide(false);
        setHasFocusTrap(false);
    }, [ref]);
    // keyboard interactions
    var handleKeyDown = React.useCallback(function (e) {
        e.key === "Escape" && hide();
        disclosure && disclosure.focus();
        // for savant panel, which listens to keyDown to close
        if (["Escape", "Esc"].includes(e.key)) {
            hide();
            e.stopPropagation();
        }
    }, [hide]);
    var handleKeyUp = React.useCallback(function (e) {
        hasClickKey(e.key) && setHasFocusTrap(hasFocusableElements(ref));
        ["Escape", "Esc"].includes(e.key) && e.stopPropagation();
    }, [ref]);
    React.useEffect(function () {
        if (!disclosure)
            return;
        disclosure.addEventListener("keydown", handleKeyDown);
        disclosure.addEventListener("keyup", handleKeyUp);
        return function () {
            disclosure.removeEventListener("keydown", handleKeyDown);
            disclosure.removeEventListener("keyup", handleKeyUp);
        };
    }, [disclosure, handleKeyDown]);
    return (React.createElement("div", __assign({ ref: refCallback, "data-oui-dropdown": "pos: top-left", className: "oui-tooltip oui-text-default-line-height", "data-test-id": testId, onKeyDown: useAllCallbacks_1.default(handleKeyDown, onKeyDown), role: Aria_1.Roles.Region }, rest),
        React.createElement(FocusTrap_1.default, { disabled: !hasFocusTrap }, children)));
};
exports.default = Tooltip;
//# sourceMappingURL=Tooltip.js.map